// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wlDA","label":"styles_label__esAFH"};